import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function InputField(props) {
    const { 
        placeholder, 
        type, 
        name, 
        id, 
        iconName, 
        onBlur, 
        onChange, 
        value, 
        errors, 
        touched, 
        labelText 
    } = props;
    
    const [passwordVisible, setPasswordVisible] = useState(false);
    
    return (
        <div className="form-group">
            {labelText && (
                <label htmlFor={id || name} className="form-label">
                    {labelText}
                </label>
            )}
            
            <div className="position-relative">
                {iconName && (
                    <span className="icon-container">
                        <FontAwesomeIcon icon={iconName} />
                    </span>
                )}

                <input
                    type={passwordVisible ? 'text' : type}
                    className="form-control"
                    autoComplete="off"
                    placeholder={placeholder}
                    name={name}
                    id={id || name}
                    onBlur={onBlur}
                    onChange={onChange}
                    value={value}
                />
                
                {type === 'password' && (
                    <span 
                        className="password-toggle" 
                        onClick={() => setPasswordVisible(!passwordVisible)}
                    >
                        <FontAwesomeIcon 
                            icon={!passwordVisible ? 'fa-eye' : 'fa-eye-slash'} 
                        />
                    </span>
                )}
            </div>

            {errors && touched && (
                <div className="form-text error">{errors}</div>
            )}
        </div>
    )
}

export default InputField